import { isConsultationCompleted } from "~/providers/utils";
import { ReimbursementExport } from "~/providers/utils/types/consultation";
import { useGetPatient } from "../useGetPatient";
import { useListPatientZoomMeetings } from "../useListPatientZoomMeetings";
import { useGetConsultationReport } from "./useGetConsultationReport";
import { useGetReimbursementReport } from "./useGetReimbursementReport";

export const useGetReimbursementExport = ({
  patientId,
}: {
  patientId: string;
}): { isLoading: boolean; data: ReimbursementExport | undefined } => {
  const patientQuery = useGetPatient(patientId);

  const consultation = patientQuery.data?.consultation;
  const isConsultationComplete = isConsultationCompleted(consultation?.status);

  const reportQuery = useGetReimbursementReport(consultation?.id, {
    enabled: isConsultationComplete && !!consultation?.id,
    staleTime: 5000,
  });

  const consultationReportQuery = useGetConsultationReport(consultation?.id, {
    enabled: isConsultationComplete && !!consultation?.id,
    staleTime: 5000,
  });

  const meetingsQuery = useListPatientZoomMeetings({
    patientId,
    enabled: !!patientId && !!reportQuery.data?.zoom_meeting_id,
  });

  const isLoading =
    patientQuery.isLoading ||
    reportQuery.isLoading ||
    consultationReportQuery.isLoading ||
    meetingsQuery.isLoading;

  const report = reportQuery.data;

  if (!patientQuery.data || !report?.completed_at) {
    return { isLoading, data: undefined };
  }

  const matchingMeeting = meetingsQuery.data?.items.find(
    (meeting) => meeting.zoom_meeting_id === report.zoom_meeting_id,
  );

  return {
    isLoading,
    data: {
      patient: patientQuery.data,
      report,
      basicPatientInformation:
        consultationReportQuery.data?.basic_patient_information,
      actualStartTime: matchingMeeting?.actual_start_time,
      actualEndTime: matchingMeeting?.actual_end_time,
    },
  };
};
